const config = {
  // Environment
  NODE_ENV: 'production',

  // Auth
  auth: {
    id: 'DIhZXu24VwmDBzv0SotViwpqO0DhnDqs',
    client: {
      url: 'https://amazingco.au.auth0.com/oauth/token',
      secret: 'eDZUb9qrIOYNgJ2E4xJuVu3Eq97YUTKwGziE1iDB4Ceupy_h5Dx7Hxh7n5tZ3ZSS',
      audiences: {
        auth0: 'https://amazingco.au.auth0.com/api/v2',
        experienceAPI: 'https://experience-api.amazingco.me',
      },
      grantType: 'client_credentials',
      clientConnection: 'ac-users-prod',
      scopes: {
        experienceAPI: [
          'openid',
          'profile',
          'email',
          'create:items',
          'update:items',
          'create:clues',
          'update:clues',
          'create:places',
          'update:places',
          'create:mtes',
          'update:mtes',
          'create:providers',
          'update:providers',
          'create:routes',
          'update:routes',
          'read:bookings',
          'update:bookings',
        ],
      },
    },
    web: {
      audienceKey: 'experienceAPI',
      domain: 'amazingco.au.auth0.com',
      logoutURL: 'https://aex-hq.amazingco.me/logout',
      realm: 'ac-users-prod',
      redirectURL: 'https://aex-hq.amazingco.me/callback',
      responseType: 'token id_token',
      signUpURL: 'https://amazingco.au.auth0.com/dbconnections/signup',
      userAPIURL: 'https://user-api.amazingco.me',
    },
  },

  // Internal services
  eeeURL: 'https://eee.amazingco.me',
  experienceAPIURL: 'https://experience-api.amazingco.me',
  hqURL: 'https://hq.amazingco.me',
  productHQURL: 'http://product-ui.amazingco.me',
  providersHQURL: 'https://provider.amazingco.me',
  notificationAPIURL: 'https://notification-api.amazingco.me',
  googleMapURL: 'https://www.google.com',
  productSearchAPIURL: 'https://product-search-api.amazingco.me',
  GTMContainerId: 'GTM-MRFNJLT',  
  contentAPIUrl: 'https://content-api.amazingco.me/api/v2',
  contentAPIV1Url: 'https://content-api.amazingco.me/api/v1',
  userAPIURL: 'https://user-api.amazingco.me',
  signUpURL: 'https://amazingco.au.auth0.com/dbconnections/signup',
  realm: 'ac-users-prod',
  muiProLicenseKey: '213b8603b0739480820dc92ddeb5875bT1JERVI6NDc4OTUsRVhQSVJZPTE2OTAzODcyMDAwMDAsS0VZVkVSU0lPTj0x',
};

export default config;
